import {RootState} from '../../../store';
import {createSelector} from '@reduxjs/toolkit';

const selectBillingState = (state: RootState) => state.billing;

// ─── Базовые ───
export const selectBillingStatus = createSelector(
    [selectBillingState],
    (s) => s.status,
);

export const selectIsRestricted = createSelector(
    [selectBillingState],
    (s) => s.status === 'restricted',
);

export const selectIsGrace = createSelector(
    [selectBillingState],
    (s) => s.status === 'grace',
);

export const selectThresholdWarning = createSelector(
    [selectBillingState],
    (s) => s.threshold_warning,
);

export const selectForecastDays = createSelector(
    [selectBillingState],
    (s) => s.forecast_days,
);

// ─── Числовые показатели ───
export const selectBillingBalance = createSelector(
    [selectBillingState],
    (s) => s.balance,
);

export const selectBillingCreditLimit = createSelector(
    [selectBillingState],
    (s) => s.credit_limit,
);

export const selectBillingDailyCost = createSelector(
    [selectBillingState],
    (s) => s.daily_cost,
);

export const selectBillingUnit = createSelector(
    [selectBillingState],
    (s) => s.unit,
);

export const selectBlockedAt = createSelector(
    [selectBillingState],
    (s) => s.blocked_at,
);

// ─── Состояние подключения и модалки ───
export const selectBillingConnected = createSelector(
    [selectBillingState],
    (s) => s.connected,
);

export const selectBillingModalOpen = createSelector(
    [selectBillingState],
    (s) => s.modal_open,
);

export const selectBillingSignature = createSelector(
    [selectBillingState],
    (s) => s.current_signature,
);

// ─── Служебные ───
export const selectBillingIsLoading = createSelector(
    [selectBillingState],
    (s) => s.is_loading,
);

export const selectBillingLastFetchedAt = createSelector(
    [selectBillingState],
    (s) => s.last_fetched_at,
);